<template>
  <div style="text-align: center">
    <p>The data with Task ID <strong>{{this.$route.query.sid}}</strong> is submitted successfully. </p>
    <p>Please wait patiently for the generation result.</p>
    <p>The status of the current task is <strong>{{Category}}</strong></p>
    <el-result icon="success" title="Summit successfully!" subTitle="">
      <template slot="extra">
        <el-button type="primary" size="medium" @click="$router.push('/home')">Back</el-button>
      </template>
    </el-result>

  </div>
</template>

<script>
export default {
  name: "Success",
  data()
  {
    return{
      Category:'',
      second:3,
      uid:'',
      sid:''
    }
  },

  created() {
    this.uid=this.$route.query.sid

    axios.get("/getCategory",{params:{uuid:this.uid}}).then(res => {
      this.Category=res.data
      console.log(this.Category)
    })

    var that=this
    var st = setInterval(function(){
      axios.get("/getCategory",{params:{uuid:that.uid}}).then(res => {
        that.Category=res.data
        console.log(that.Category)
        if(that.Category===1)
        {
          console.log("Ok")
          that.$router.push({
            path: '/result',
            query: {
              sid: that.uid
            }
          })
          clearInterval(st);
        }

        if(that.Category=="wrong format")
        {
          that.$alert("Task submission failed, please check your input.","Error",{
            confirmButtonText: "OK",
            callback: action => {
              clearInterval(st);
              that.$router.push('/home')
            }
          })
          console.log(that.Category);
          clearInterval(st);
        }
      })
    },1000);

    // setInterval(function () {
    //   axios.get("/getCategory",{params:{uuid:this.uid}}).then(res => {
    //     this.Category=res.data
    //     console.log(this.Category)
    //     if (this.Category!='0'){
    //       this.$alert("success")
    //     }
    //   })
    //
    // } ,6000);

  },
  methods:{
    MyStop(){
      clearInterval(this.st);
    }
  },
}
</script>

<style scoped>

</style>
